import Component from "@glimmer/component"
import styles from "./next-button.module.css"

export default class UserOnboardingNextButtonComponent extends Component {
  readonly styles = styles
}
